export default __webpack_public_path__ + "5813a89437b21963ba66e46eba8d3837.coffee";